var map = {
	"./project/capacity-size/desktop.svg": "d232",
	"./project/capacity-size/mobile.svg": "95de",
	"./project/capacity-size/tablet.svg": "b05e",
	"./project/map-logo-svg/desktop.svg": "dd98",
	"./project/map-logo-svg/mobile.svg": "e27a",
	"./project/map-logo-svg/tablet.svg": "df02",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c4a";